import BaseModel from '../BaseModel';

export default class VacancyCandidatesCountByStatus extends BaseModel {
  static entity = 'vacancyCandidatesByStatuses';

  static primaryKey = 'status';

  static fields() {
    return {
      status: this.attr(null),
      count: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async fetchCountCandidatesByStatus(id, search = '') {
        const params = search ? { search } : {};
        const response = await this.get(`vacancies/${id}/status-count-candidates`, {
          params,
        });

        let statusCounts = [];

        if (response?.response?.data) {
          const responseData = response.response.data;

          if (responseData.data && Array.isArray(responseData.data)) {
            statusCounts = responseData.data;
          } else if (Array.isArray(responseData)) {
            statusCounts = responseData;
          }

          if (statusCounts.length > 0) {
            await this.model.insertOrUpdate({ data: statusCounts });
          }
        }

        return {
          response,
          statusCounts,
        };
      },
    },
  }
}
